import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Resource } from '../shared/models/resource';
import { IRosterCode } from '../shared/models/roster-code';

@Injectable({
  providedIn: 'root'
})
export class RosterCodeService {
  rosterCodes: {[id: number]: IRosterCode} = {
    1: { id: 1, code: "TOIL" },
    2: { id: 2, code: "PO" },
    3: { id: 3, code: "BL" },
    4: { id: 4, code: "DAY" },
    5: { id: 5, code: "NIGHT" },
    6: { id: 6, code: "RDO" },
    7: { id: 7, code: "R&R" },
    8: { id: 8, code: "INDUCT" },
    9: { id: 9, code: "AL" },
    10: { id: 10, code: "PL" },
    11: { id: 11, code: "CL" },
    12: { id: 12, code: "LWOP" },
    13: { id: 13, code: "WC" },
    14: { id: 14, code: "SD" },
    15: { id: 15, code: "FIA" },
    16: { id: 16, code: "FIP" },
    17: { id: 17, code: "FOA" },
    18: { id: 18, code: "FOP" },
    19: { id: 19, code: "DIA" },
    20: { id: 20, code: "DIP" },
    21: { id: 21, code: "DOA" },
    22: { id: 22, code: "DOP" },
    23: { id: 23, code: "SICK" },
    24: { id: 24, code: "PH" },
    25: { id: 25, code: "DS-Supervisor-DW" },
    26: { id: 26, code: "NS-Supervisor-DW" },
    27: { id: 27, code: "INDUCT" }      
  };

  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterCode[]>>{
    return this.http.get<IApiResult<IRosterCode[]>>(`${this.apiUrlProvider.url}/rostercode`);
  }

  add(entity: IRosterCode): Observable<IApiResult<IRosterCode>>{
    return this.http.post<IApiResult<IRosterCode>>(`${this.apiUrlProvider.url}/rostercode`, entity);
  }

  update(entity: IRosterCode): Observable<IApiResult<IRosterCode>>{
    return this.http.post<IApiResult<IRosterCode>>(`${this.apiUrlProvider.url}/rostercode/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/rostercode/${entityId}/delete`, null);
  }

  getRosterCode(rosterCodeId: number): IRosterCode{
    return this.rosterCodes[rosterCodeId];
  }

  isOnSite(rosterCodeId: number): boolean{
    return rosterCodeId === 4 || rosterCodeId === 5;
  }
}
